import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40eea1f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative h-[376px] top-0 border-b border-System/app_border bg-System/app_white" }
const _hoisted_2 = { class: "col flex" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "row absolute gordita-bold-700-27 text-Text/text_high w-full bottom-[86px] flex justify-center items-center",
  "data-testid": "user-profile-username"
}
const _hoisted_6 = { class: "flex row float-right h-[64px] pt-[16px] pr-[24px] bg-none" }
const _hoisted_7 = { class: "max-w-[1624px] inline-flex w-full" }
const _hoisted_8 = { class: "login row flex-center absolute p-0 bottom-0 w-full pt-[40px] pb-[24px] relative" }

import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import profileLines from '@/assets/images/userProfile/profile-lines.svg';
import userAvatar from '@/assets/images/userProfile/user-avatar.svg';
import { IncrediTab, IncrediTabList, IncrediCard } from 'incredi-ui';
import UserNotifications from '@/components/common/userNotifications/userNotifications.vue';
import { useUserQuery } from '@/graphql/codegen/generated/graphql';
import { Routes } from '@/router/router.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'userInfoProfile',
  setup(__props) {

const GQL_userInfo = useUserQuery();
const userName = computed(() => GQL_userInfo.result.value?.user?.userName || '');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(IbxScopedCss, {
    class: "m-0 inline-flex flex-col absolute",
    style: {"width":"100%","height":"100%"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[1162px] absolute left-0 top-0",
            src: _unref(profileLines),
            alt: "profile-Lines"
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            class: "absolute w-full h-[144px] bottom-[140px] flex justify-center items-center",
            src: _unref(userAvatar)
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userName)), 1),
          _createVNode(_unref(IncrediTabList), { class: "row flex-center absolute p-0 bottom-0 w-full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IncrediTab), {
                "data-testid": "user-profile--personal-info-tab",
                index: 0,
                to: _unref(Routes).PersonalInfo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('userProfile.personalInfoTab.title')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_unref(IncrediTab), {
                "data-testid": "user-profile--change-password-tab",
                index: 1,
                to: _unref(Routes).ChangePassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('userProfile.changePasswordTab.title')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_unref(IncrediTab), {
                "data-testid": "user-profile--preferences-tab",
                index: 2,
                to: _unref(Routes).Preferences
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('userProfile.preferencesTab.title')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(UserNotifications)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(IncrediCard), { class: "w-[480px]" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})